/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-09-20 21:58:52
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-12-12 15:35:36
 * @FilePath: /console-znzs/new_src/vuex/index.js
 */
import store from '@/znzs/src/vuex';

export default store;